import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import * as echarts from "echarts";
import { nextTick, ref, watch } from "vue";
export default {
  __name: 'gauge',
  props: {
    gaugeData: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const gauge = ref("");
    const myChart = ref(null);
    let gaugeDataHandle = val => {
      var option = {
        series: [{
          min: 0,
          max: 3,
          type: 'gauge',
          axisLine: {
            lineStyle: {
              width: 10,
              color: [[0.3, '#67e0e3'], [0.7, '#37a2da'], [1, '#fd666d']]
            }
          },
          pointer: {
            itemStyle: {
              color: 'inherit'
            }
          },
          axisTick: {
            distance: -10,
            length: 4,
            lineStyle: {
              color: '#fff',
              width: 1
            }
          },
          splitLine: {
            distance: -10,
            length: 10,
            lineStyle: {
              color: '#fff',
              width: 2
            }
          },
          axisLabel: {
            color: 'inherit',
            distance: 10,
            fontSize: 12
          },
          detail: {
            valueAnimation: true,
            formatter: '{value} V',
            color: 'inherit',
            fontSize: 12
          },
          data: [{
            value: 2
          }]
        }]
      };
      nextTick(() => {
        let chartDom = gauge.value;
        let chart = echarts.init(chartDom);
        chart.resize();
        chart.setOption(option);
        myChart.value = chart;
      });
    };
    watch(() => {
      return props.gaugeData;
    }, val => {
      console.log("watch");
      if (val) {
        gaugeDataHandle(val);
      }
    }, {
      immediate: true
    });
    window.addEventListener('resize', () => {
      myChart.value.resize();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "gauge",
        ref_key: "gauge",
        ref: gauge
      }, null, 512);
    };
  }
};